import { z } from 'zod/v4';
import { VoucherCategory, VoucherTypeIds } from '../economy/vouchers/index.js';
export var VoucherApplicationTarget;
(function (VoucherApplicationTarget) {
    VoucherApplicationTarget["Company"] = "COMPANY";
    VoucherApplicationTarget["Person"] = "PERSON";
    VoucherApplicationTarget["Both"] = "BOTH";
})(VoucherApplicationTarget || (VoucherApplicationTarget = {}));
export var VoucherApplicationType;
(function (VoucherApplicationType) {
    VoucherApplicationType["VoucherType"] = "VOUCHER_TYPE";
    VoucherApplicationType["VoucherCategory"] = "VOUCHER_CATEGORY";
    VoucherApplicationType["Case"] = "CASE";
})(VoucherApplicationType || (VoucherApplicationType = {}));
export var InterestFrom;
(function (InterestFrom) {
    InterestFrom["Date"] = "DATE";
    InterestFrom["DueDate"] = "DUE_DATE";
})(InterestFrom || (InterestFrom = {}));
const InterestOptionsSchema = z.object({
    days: z.number(),
    from: z.enum(InterestFrom),
    fromDateProperty: z.string().optional(),
});
const BaseVoucherApplicationSchema = z
    .object({
    target: z.enum(VoucherApplicationTarget),
})
    .and(z.discriminatedUnion('voucherType', [
    z.object({
        voucherType: z.literal(VoucherTypeIds.GLPROCESSINTEREST),
        voucherOptions: InterestOptionsSchema,
    }),
    z.object({
        voucherType: z.literal(VoucherTypeIds.PROCESSINTEREST),
        voucherOptions: InterestOptionsSchema,
    }),
    z.object({
        voucherType: z.literal(VoucherTypeIds.YEARLYINTEREST),
        voucherOptions: InterestOptionsSchema.and(z.object({
            interestRate: z.number(),
        })),
    }),
    z.object({
        voucherType: z.literal(VoucherTypeIds.FIXEDINTEREST),
        voucherOptions: InterestOptionsSchema.and(z.object({
            amount: z.number(),
        })),
    }),
    z.object({
        voucherType: z.literal([
            ...Object.values(VoucherTypeIds).filter((val) => val !== VoucherTypeIds.GLPROCESSINTEREST &&
                val !== VoucherTypeIds.PROCESSINTEREST &&
                val !== VoucherTypeIds.YEARLYINTEREST &&
                val !== VoucherTypeIds.FIXEDINTEREST),
        ]),
        voucherOptions: z.object({
            amount: z.number(),
        }),
    }),
]));
export const VoucherApplicationSchema = z.union([
    z
        .object({
        type: z.literal(VoucherApplicationType.VoucherType),
        applyToVoucherType: z.enum(VoucherTypeIds),
    })
        .and(BaseVoucherApplicationSchema),
    z
        .object({
        type: z.literal(VoucherApplicationType.VoucherCategory),
        applyToVoucherCategory: z.enum(VoucherCategory),
    })
        .and(BaseVoucherApplicationSchema),
    z
        .object({
        type: z.literal(VoucherApplicationType.Case),
    })
        .and(BaseVoucherApplicationSchema),
]);
export const CreateVoucherApplicationSchema = z.object({
    application: VoucherApplicationSchema,
    creditorId: z.uuid().optional(),
});
export const UpdateVoucherApplicationContextSchema = z.object({
    enabled: z.boolean().optional(),
});
//# sourceMappingURL=index.js.map